export default "__VITE_ASSET__B9hT7qf9__"